import defaultSiteImage from '../site/images/default.jpg';
import site from '../site';

const getAbsoluteUrl = (path) => (
  process.env.NODE_ENV === 'production' ? `${site.url}${path}` : path
);

export default {
  default: {
    title: 'Web development and design firm',
    description: 'We are web technology experts. Hire us to build you a world-class website or web app. Let\'s talk about your project.',
    image: getAbsoluteUrl(defaultSiteImage),
    facebook: site.meta.facebook,
    twitter: site.meta.twitter,
  },
  '/work/': {
    title: 'Our clients - Web design',
    description: 'We are experts in website and application development. We\'ve been producing top quality products, for dozens of clients, for over 8 years. We work fast and deliver faster.',
  },
  '/work/aquarisk/': {
    title: 'Aquarisk - Web development project',
  },
  '/work/betasmartz/': {
    title: 'Betasmartz - Fintech app development',
  },
  '/work/blacklight/': {
    title: 'Blacklight - Web app development',
  },
  '/work/buddybet/': {
    title: 'Buddybet - Mobile app development',
  },
  '/work/linguaphone/': {
    title: 'Linguaphone - Ecommerce website design',
  },
  '/work/llanoseco/': {
    title: 'Llano Seco Rancho - Web design',
  },
  '/work/macau-news/': {
    title: 'Macau News - Web design',
  },
  '/work/pesposa/': {
    title: 'Pesposa - End-to-end web development',
  },
  '/work/pingusenglish/': {
    title: 'Pingusenglish - Web design',
  },
  '/work/spindal/': {
    title: 'Spindal - Web application development',
  },
  '/work/upwork/': {
    title: 'Upwork - Premium Member',
  },
  '/work/vands/': {
    title: 'Victors and Spoils - Web application development',
  },
  '/work/wisense/': {
    title: 'Wisense - Web development',
  },
  '/work/witsbits/': {
    title: 'Witsbits - Web application development',
  },
  '/tos/': {
    title: 'Terms of Service - Privacy Policy',
  },
};



// WEBPACK FOOTER //
// ./src/app/data/seo/index.js